"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function isPrezzeeElement(element, names) {
    var _a;
    return (0, react_1.isValidElement)(element) && names.indexOf((_a = element.type) === null || _a === void 0 ? void 0 : _a.displayName) !== -1;
}
exports.default = isPrezzeeElement;
//# sourceMappingURL=isPrezzeeElement.js.map